import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { Container, Badge, Icon } from '@pella/sash-framework';
import { classNames } from '@pella/sash-framework/dist/utilities';
import { Layout, SEO, Breadcrumbs } from '../../components';

import Cards from '../../components/common/cards';
import CardRenderer from '../../components/common/card-renderer';
import Video from '../../components/common/video';
import ProductHero from '../../components/common/hero-product';

import './index.css';

const Category = (props) => {
	const pageData = props.data.contentstackCategory;

	const heroClasses = classNames({
		'catHero': true,
		'pb-6 text-secondary-dark': pageData.page_type === 'material',
		'text-white': pageData.page_type !== 'material',
	});

	return (
		<Layout>
			{pageData.breadcrumbs && <Breadcrumbs data={pageData.breadcrumbs} />}

			{pageData.hero && (
				<ProductHero
					data={pageData.hero}
					className={heroClasses}
					isPDP
				/>
			)}

			{pageData.modular_blocks?.[0] &&
				pageData.modular_blocks.map((block, index) => {
					if (block.highlights != null) {
						const gridClasses = classNames({
							'catHighlights-grid grid gap-2 xl:gap-3': true,
							'grid-cols-1 md:grid-cols-2 md:auto-rows-min xl:auto-rows-fr xl:grid-cols-[1fr_1fr_2.5fr]': pageData.page_type === 'impact',
							'grid-cols-1 md:auto-cols-fr xl:grid-cols-3': pageData.page_type !== 'impact',
						});

						return (
							<div
								key={index}
								className={`catHighlights py-8 xl:py-12 ${pageData.page_type !== 'material' ? 'md:pt-0 lg:pt-8' : ''}`}
							>
								<Container>
									<div className={pageData.page_type !== 'material' && pageData.hero?.image?.[0] ? 'lg:w-[calc(100%-40px-272px)] xl:w-[calc(100%-80px-315px)]' : ''}>
										{block.highlights.heading && <h2 className='mb-2 font-bold'>{block.highlights.heading}</h2>}
										{block.highlights.description && (
											<div
												className='mb-4'
												dangerouslySetInnerHTML={{ __html: block.highlights.description }}
											/>
										)}

										{block.highlights.cards?.[0] && (
											<div className={gridClasses}>
												{block.highlights.cards.map((card, index) => (
													<div
														key={index}
														className={classNames({
															[`col-start-1 md:max-xl:row-start-1 md:col-start-${index + 1} xl:col-start-1`]: pageData.page_type === 'impact' && index % 2 === 0,
															[`col-start-1 md:max-xl:row-start-1 md:col-start-${index + 1} xl:col-start-2`]: pageData.page_type === 'impact' && index % 2 !== 0,
															'col-start-1 md:col-span-2 xl:col-span-1': pageData.page_type === 'type' && (index + 1) % 3 === 0,
														})}
													>
														<CardRenderer
															data={card}
															className='!py-6 [&_span]:!mb-4'
														/>
													</div>
												))}
												{block.highlights.video?.[0] && (
													<div className='col-span-1 md:col-span-4 md:col-start-1 md:row-start-2 xl:col-span-1 xl:col-start-3 xl:row-span-2 xl:row-start-1'>
														<Video
															data={block.highlights.video[0]}
															className='h-full'
														/>
													</div>
												)}
											</div>
										)}
									</div>
								</Container>
							</div>
						);
					}

					if (block.cards?.cards?.[0]) {
						return (
							<Cards
								key={index}
								data={block.cards}
								className='py-8 md:py-6 xl:py-12'
							/>
						);
					}
				})}
		</Layout>
	);
};

Category.propTypes = {
	data: PropTypes.object,
};

export default Category;

// eslint-disable-next-line react/prop-types -- gatsby component
export const Head = (props) => <SEO {...props.data.contentstackCategory.seo} />;

export const query = graphql`
	query ($uid: String!) {
		contentstackCategory(uid: { eq: $uid }) {
			url
			page_type
			breadcrumbs {
				...Breadcrumbs
			}
			hero {
				heading
				description
				background_hex_value
				image {
					...Image
				}
			}
			modular_blocks {
				highlights {
					heading
					description
					cards {
						...Card
					}
					video {
						...Video
					}
				}
				cards {
					...CardSection
				}
			}
			seo {
				...SEO
			}
		}
	}
`;
